import React, { useState, useEffect } from 'react';
import ModernGanttChart from '../components/Dashboard/ModernGanttChart';
import CitySearchSelect from '../components/CitySearchSelect';
import client from '../api/client';
import { useToast } from '../context/ToastContext';
import { createScheduleUpdateHandler } from '../utils/scheduleUpdateWithCascade';
import { getApiErrorMessage } from '../utils/apiErrorMessage';

const DirectiveSchedule = () => {
  const [cities, setCities] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const { showError } = useToast();

  useEffect(() => {
    fetchCities();
  }, []);

  useEffect(() => {
    fetchSchedules();
  }, [selectedCity]);

  const fetchCities = async () => {
    try {
      const response = await client.get('/cities');
      // Фильтруем только объекты, которые должны отображаться в графиках
      const visibleCities = response.data.filter(city => city.visible_in_schedules !== false);
      setCities(visibleCities);
    } catch (error) {
      console.error('Error fetching cities:', error);
      showError(getApiErrorMessage(error, 'Ошибка при загрузке объектов'));
    }
  };

  const loadSchedules = async (showLoading = true) => {
    try {
      if (showLoading) setLoading(true);
      const params = selectedCity ? { city_id: selectedCity } : {};
      const response = await client.get('/schedules', { params });
      setSchedules(response.data);
    } catch (error) {
      console.error('Error fetching schedules:', error);
      showError(getApiErrorMessage(error, 'Ошибка при загрузке графика'));
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  const fetchSchedules = () => loadSchedules(true);
  const fetchSchedulesBackground = () => loadSchedules(false);

  const handleScheduleUpdate = createScheduleUpdateHandler({
    fetchSchedules: fetchSchedulesBackground,
    showError,
    cityId: selectedCity,
    backgroundRefetch: true
  });

  return (
    <div className="container-fluid">
      <h1>Директивный агрегированный график</h1>
      
      <div className="card" style={{ maxWidth: '600px' }}>
        <div className="form-group">
          <label className="form-label">Выберите объект строительства</label>
          <CitySearchSelect
            cities={cities}
            value={selectedCity}
            onChange={(cityId) => setSelectedCity(cityId ?? null)}
            allowEmpty
            emptyLabel="Все объекты"
            placeholder="Все объекты"
            testIdPrefix="directive-city"
          />
        </div>
      </div>

      <div className="card-full-width">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div>Загрузка данных...</div>
          </div>
        ) : (
          <ModernGanttChart schedules={schedules} cities={cities} onScheduleUpdate={handleScheduleUpdate} defaultDragDisabled={true} dependencyCityId={selectedCity || undefined} />
        )}
      </div>
    </div>
  );
};

export default DirectiveSchedule;
